<template>
  <!-- 解决方案 -->
  <div>
    <div v-if="this.$route.path == '/mobile/programme'">
      <!-- 顶部导航 -->
      <TopNav></TopNav>
      <!-- 解决方案轮播图 -->
      <ProgrammeBanner></ProgrammeBanner>
      <!-- 物联网智能硬件 -->
      <Hardware></Hardware>
      <!-- 行业解决方案 -->
      <Programme></Programme>
      <!-- 通用解决方案 -->
      <Currency></Currency>
      <!-- 底部导航 -->
      <BottomNav></BottomNav>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../components/mobile/components/TopNav.vue";
import BottomNav from "../../../components/mobile/components/BottomNav.vue";
import ProgrammeBanner from "../../../components/mobile/Programme/ProgrammeBanner.vue";
import Hardware from "../../../components/mobile/Programme/Hardware.vue";
import Programme from "../../../components/mobile/Programme/Programme.vue";
import Currency from "../../../components/mobile/Programme/Currency.vue";

export default {
  setup() {
    return reactive({});
  },
  components: {
    TopNav,
    BottomNav,
    ProgrammeBanner,
    Hardware,
    Programme,
    Currency,
  },
};
</script>

<style scoped>
</style>
